import { render, staticRenderFns } from "./heim-card.vue?vue&type=template&id=77a58ad0&scoped=true&"
import script from "./heim-card.vue?vue&type=script&lang=js&"
export * from "./heim-card.vue?vue&type=script&lang=js&"
import style0 from "./heim-card.vue?vue&type=style&index=0&id=77a58ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a58ad0",
  null
  
)

component.options.__file = "heim-card.vue"
export default component.exports